/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import {
  CREATE_FAQ,
  UPDATE_FAQ,
} from 'pages/ApplicationUI/ApplicationUIGraphQL';
import { FAQ_TYPES } from 'pages/ApplicationUI/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import AddEditFAQForm from './components/AddEditFAQForm';
import { FAQValidationSchema } from '../../constants';

const AddEditFAQ = ({ toggleFAQForm, type, value, refetch = () => {} }) => {
  const [createFAQ] = useMutation(CREATE_FAQ, {
    onCompleted: ({ createFAQ }) => {
      if (createFAQ?.id) toast.success('FAQ created successfully');
      refetch();
      toggleFAQForm();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
      toggleFAQForm();
    },
  });

  const [updateFAQ] = useMutation(UPDATE_FAQ, {
    onCompleted: ({ updateFAQ }) => {
      if (updateFAQ?.id) toast.success('FAQ updated successfully');
      refetch();
      toggleFAQForm();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
      toggleFAQForm();
    },
  });

  const handleSubmit = async (values) => {
    if (type === ADD_EDIT_CONSTANT.ADD)
      await createFAQ({
        variables: {
          createFAQ: {
            ...values,
            faqCategory: values?.faqCategory?.id,
          },
        },
      });
    else {
      await updateFAQ({
        variables: {
          updateFAQ: {
            id: values?.id,
            question: values?.question,
            answer: values?.answer,
            faqCategory: values?.faqCategory?.id,
          },
        },
      });
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? {
                  ...value,
                  faqCategory: {
                    id: value?.faqCategory,
                    label:
                      value?.faqCategory === FAQ_TYPES.INDIAN_FAQ
                        ? 'INDIAN'
                        : 'FOREIGN',
                  },
                }
              : {
                  question: '',
                  answer: '',
                  faqCategory: '',
                }
          }
          enableReinitialize
          validationSchema={FAQValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditFAQForm
                {...props}
                type={type}
                toggleFAQForm={toggleFAQForm}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditFAQ;
